// LIBRARIES
import styled from "styled-components";
//MISC

import { COLORS, SIZE, BORDER_RADIUS } from "constants/variables";

export const Pill = styled.div<{ status?: boolean }>`
  display: flex;
  align-items: stretch;
  justify-content: center;
  border: none;
  border-radius: ${BORDER_RADIUS.radius21};
  width: 100%;
  height: 100% !important;
  background-color: ${(props) =>
    props.status ? COLORS.Orange : COLORS.Crimson};
  padding: ${SIZE.max10} ${SIZE.max16};
`;
